/**
 * MobileOrientationLock — Mantiene la experiencia operativa en retrato.
 * Intenta el bloqueo nativo y cubre la interfaz cuando un móvil web queda en paisaje.
 */
import { useEffect } from "react";
import { RotateCw } from "lucide-react";
import { isNative } from "@/lib/platform";

interface LockableScreenOrientation extends ScreenOrientation {
  lock?: (orientation: "portrait") => Promise<void>;
}

export default function MobileOrientationLock() {
  useEffect(() => {
    if (!isNative || typeof screen === "undefined") {
      return undefined;
    }
    const orientation = screen.orientation as LockableScreenOrientation;
    if (!orientation.lock) return undefined;

    void orientation.lock("portrait").catch(() => undefined);
    return () => orientation.unlock?.();
  }, []);

  return (
    <div
      className="app-mobile-orientation-lock"
      role="alert"
      aria-live="assertive"
    >
      <RotateCw size={32} aria-hidden />
      <p className="text-sm font-bold">Usa ALTENOT en posición vertical</p>
      <p className="text-xs text-slate-300">
        Gira tu dispositivo para continuar.
      </p>
    </div>
  );
}
